import React from 'react'
import { Field, RadioGroup } from '@workwhile/ui'
import {
  COMPANY_TYPE_OPTIONS,
  CompanyTypeValue,
} from 'api/companies/companyType'

type CompanyTypeFieldProps = {
  value: CompanyTypeValue
  onChange: (value: CompanyTypeValue) => void
  error?: string
  mt?: number
}

// Worker-classification selector (1099 / W2 / W2-with-E-Verify), shared by the create and edit-general-details flows.
export const CompanyTypeField = ({
  value,
  onChange,
  error,
  mt = 3,
}: CompanyTypeFieldProps) => {
  return (
    <Field
      label="Type"
      error={error}
      // Intentionally disabled.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      mt={mt}
      width="fit-content"
    >
      <RadioGroup
        name="companyType"
        value={value}
        onChange={(next) => onChange(next as CompanyTypeValue)}
        // Intentionally disabled.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        flexDirection={['column', 'row']}
        gap={5}
        options={COMPANY_TYPE_OPTIONS}
      />
    </Field>
  )
}
